// extracted by mini-css-extract-plugin
export var statItem = "_c1-1";
export var statsRow = "_c1-0";